import { render, staticRenderFns } from "./integral-mall-goods-list.vue?vue&type=template&id=7213d8c3"
import script from "./integral-mall-goods-list.vue?vue&type=script&lang=ts"
export * from "./integral-mall-goods-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports